exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-item-tab[data-v-17ad2cbb] {\n  width: 100%;\n  height: 48px;\n  background-color: #27cf5a;\n}\n.item-list[data-v-17ad2cbb] {\n  border-bottom: 1px solid;\n  border-color: #cfcfcf;\n}\n.item-amout-box[data-v-17ad2cbb] {\n  width: 88px;\n  height: 36px;\n  border: solid 1px #1b0000;\n  font-size: 18px;\n  font-weight: bold;\n}\n.add-item[data-v-17ad2cbb] {\n  font-size: 24px;\n  font-weight: bold;\n  color: #ffffff;\n  width: 36px;\n  height: 36px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border: solid 1px #1b0000;\n}\n.minus-item[data-v-17ad2cbb] {\n  font-size: 24px;\n  font-weight: bold;\n  color: #ffffff;\n  width: 36px;\n  height: 36px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border: solid 1px #1b0000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17ad2cbb","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home/ListProduct.vue
// module id = 401
// module chunks = 1